import { put, call, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';

function* partnerPostListGet(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('pic', payload.pic);
    params.append('page', payload.page);
    return axios.post(config.apiUri + "member/partnerPostApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool) {
      yield put({
        type: "PARTNER_POST_SET",
        payload: {
          pic: action.payload.pic,
          list: res.data.list,
          page: action.payload.page,
          isListNext: res.data.isListNext,
        }
      });

    }
    action.callback(res.data);
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


function* partnerPostGoodEdit(action) {
  const {res, err} = yield call( function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('postId', payload.postId);
    return axios.post(config.apiUri + "member/partnerPostGoodEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);


  if (res) {
    if (res.data.bool) {
      let goodSended;
      if (res.data.type === 'add') {
        goodSended = 1;
      }
      else if (res.data.type === 'del') {
        goodSended = 0;
      }

      yield put({
        type: "COMMUNITY_POST_GOOD_SET",
        payload: {
          postId: action.payload.postId,
          goodSended: goodSended,
          goodCount: res.data.goodCount,
        },
      });

      yield put({
        type: "TIMELINE_POST_GOOD_SET",
        payload: {
          postId: action.payload.postId,
          goodSended: goodSended,
          goodCount: res.data.goodCount,
        },
      });
      action.callback(res.data);
    }
    else {
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: res.data.comment} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
}




const saga = [
  takeLatest('PARTNER_POST_LIST_GET', partnerPostListGet),
  takeLatest('PARTNER_POST_GOOD_EDIT', partnerPostGoodEdit),
];

export default saga;
